var render, staticRenderFns
import script from "./CustomHtmlComponent.vue?vue&type=script&lang=js&"
export * from "./CustomHtmlComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b02b7c",
  null
  
)

export default component.exports